<template>
  <div style="display: none;"></div>
</template>

<script>
export default {
  name: 'VariablesCSS'
};
</script>

<style>
:root {
  /* Additional variables not in course-variables.css */
  --secondary-color: #8b5cf6;
  --accent-color: #ec4899;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #6b7280;
  --bg-light: #f9fafb;
  --bg-white: #ffffff;
  --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.1);
  --radius-sm: 0.375rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;
  --radius-2xl: 1.5rem;
  --transition-smooth: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style> 